import { Location } from '@angular/common';
import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuditsModel } from '../audits.model';
import { AuditsService } from '../audits.service';
import { MatDialog } from '@angular/material/dialog';
import { AuditItemModel } from 'src/app/audit-items/audit-item.model';
import { AuditsViewItemsComponent } from './audits-view-items/audits-view-items.component';
import { RBACService } from 'src/app/shared/rbac.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { UserPublicProfileComponent } from '../../shared/user-public-profile/user-public-profile.component';
import { MatPaginator } from '@angular/material/paginator';
import { ApiRequestService } from '../../shared/api-request.service';
import { AssetsService } from '../../assets/assets.service';

@Component({
  selector: 'app-audits-view',
  templateUrl: './audits-view.component.html',
  styleUrls: ['./audits-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuditsViewComponent implements OnInit {
  audit = new AuditsModel();
  displayedColumns = [
    'id',
    'name',
    'status',
    'date_created',
    // 'date_created_UTC',
    'date_modified',
    // 'date_modified_UTC',
    'actions'
  ];
  displayedContractorColumns = ['name', 'industry', 'address', 'actions'];
  displayedContactsColumns = ['contact_name', 'email', 'user_status'];
  displayedAssetColumns = [
    'name',
    'code',
    'asset_type',
    'status',
    'condition_rating'
  ];

  contactDataSource;
  auditId: number;

  // RBAC permission flags: resolved once in ngOnInit().
  canView: boolean = false;
  canEdit: boolean = false;

  /**
   * A unique list of sections.
   */
  sections: string[] = [];

  /**
   * Audit items grouped by section.
   */
  sectionsItems: { [section: string]: AuditItemModel[] } = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private api: ApiRequestService,
    private activatedRoute: ActivatedRoute,
    private auditsService: AuditsService,
    private dialog: MatDialog,
    public utils: UtilsService,
    public location: Location,
    public rbac: RBACService,
    public assetsService: AssetsService
  ) {}

  ngOnInit() {
    // 1. Check view permission: redirect back if denied.
    this.canView = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_REGISTERS_INSPECTIONS_AUDITS,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    if (!this.canView) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to view inspections & audits.'
      );
      this.location.back();
      return;
    }

    // 2. Resolve canEdit flag for Edit button visibility.
    this.canEdit = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_REGISTERS_INSPECTIONS_AUDITS,
          RBACService.RBAC_A.A_EDIT
        )
      ],
      true
    );

    this.auditId = Number(this.activatedRoute.snapshot.params['id']);
    this.auditsService.find(this.auditId).subscribe((response) => {
      this.audit = response.data;

      this.audit.items.forEach((item) => {
        if (this.sections.indexOf(item.section) === -1) {
          this.sections.push(item.section);
        }

        if (!this.sectionsItems[item.section]) {
          this.sectionsItems[item.section] = [];
        }
        this.sectionsItems[item.section].push(item);
      });
    });
    this.getAuditContactsApi();
  }

  getAuditContactsApi(page?) {
    this.auditsService.getContacts(this.auditId, page).subscribe((res) => {
      this.contactDataSource = res.data;
    });
  }

  onOpenUrl(url: string) {
    this.utils.openUrl(url);
  }

  downloadPdf() {
    this.api
      .makeRequest(
        'get',
        'v2/site-audits/export/pdf',
        {},
        {
          site_ids: this.audit.site.id,
          selected_ids: this.audit.id
        }
      )
      .then((response) => {
        // Check if we have a message response.
        if (typeof response.message != 'undefined') {
          this.utils.showToast(response.message);
        }
      })
      .catch((errorResponse) => {
        this.utils.showModal(
          'Failed to get export',
          'We could not get you your Inspection/Audit export. Please try again.'
        );
      });
  }

  view(item: AuditItemModel) {
    this.utils.showComponentDialog(AuditsViewItemsComponent, item, {
      width: '700px'
    });
  }

  onUserPublicView(hash: string) {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }

  handlePageEvent(e) {
    this.getAuditContactsApi(e.pageIndex + 1);
  }
}
